export default function AdminMiniStat({ label, v, ok, warn }) {
  const color = warn ? "var(--zc-warn,#f59e0b)" : ok ? "var(--zc-success)" : "var(--zc-text)";
  return (
    <div className="rounded-lg border border-[var(--zc-border)] p-3" style={{ background: "var(--zc-bg-2)" }}>
      <div className="eyebrow">{label}</div>
      <div className="zc-stat text-2xl mt-1" style={{ color }}>{v ?? "—"}</div>
    </div>
  );
}
